import {
  Box,
  Button,
  Grid,
  InputLabel,
  makeStyles,
  Paper,
  Switch,
  TextField,
} from "@material-ui/core";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import { useFormik } from "formik";
import ENV from "libs/configs/env";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import { getErrorMessage, isError } from "libs/utils/form";
import HttpClient from "libs/utils/HttpClient";
import { get } from "lodash";
import qs from "qs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  AddDepartment,
  //   getEmployeeDetail,
  updateDepartment,
} from "redux/modules/departmentSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import FileService from "services/FileService";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  content: {
    marginTop: 30,
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  wrapContent: {
    marginTop: 30,
  },
  sigPad: { width: "100%", height: "100%" },
  buttons: { width: "100%", height: "30px" },
  wrapSig: {
    padding: "10px",
    border: "1px solid lightgray",
    borderRadius: "10px",
    textAlign: "center",
  },
  sigImage: {
    backgroundSize: "200px 50px",
    width: "80%",
    height: "80%",
    backgroundColor: "white",
    borderRadius: 15,
  },
  wrapField: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },

  textField: {
    display: "flex",
    flex: 1,
    cursor: "pointer",
    marginTop: 8,
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: theme.palette.grey[100],
    },
  },
  wrapContoller: {
    display: "flex",
  },
  formControl: {
    width: "100%",
  },
  warpFormControl: {
    paddingLeft: 10,
    paddingRight: 10,
    marginTop: 10,
  },
}));

function DepartmentDetailPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { departmentId } = useParams();

  const [open, setOpen] = React.useState(false);

  const { list: roleList, isLoading } = useSelector((state) => state.role);
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();
  const { profile } = useSelector((state) => state.user);
  const masterData = useSelector(selectMasterData);
  const department = get(masterData, "department", []);
  const [deparment_data, setDepartment_data] = useState([]);
  const [fileImage, setFileImage] = useState([]);
  const history = useHistory();

  //Image
  const img = ENV.getConfig().baseUrl + "\\Public\\";
  const logoImg = profile.pathPicDepartment ? img : "/assets/images/logo.png";

  useEffect(async () => {
    await dispatch(
      getMasterData({
        department: true,
      })
    );
  }, [departmentId]);

  useEffect(() => {
    // console.log(departmentId);
    if (departmentId) {
      getDetail_Data();
    }
  }, []);

  const getDetail_Data = async () => {
    try {
      const params = qs.stringify({
        ...(departmentId && { departmentId }),
      });

      const response = await HttpClient.get(`/api/department/list?${params}`);
      if (response.results.length > 0) {
        response.results.map((res) => {
          setDepartment_data(res);
        });
      }
      //   console.log(response);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const handleClose = async (value) => {
    setOpen(false);
  };

  const validationSchema = yup.object({
    // date: yup.date().required("Date is required."),
    departmentName: yup.string().trim().required("Name  is required."),
    departmentInitials: yup.string().trim().required("Code is required."),
    depoartmentTax: yup.string().trim().required("Tax  is required."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      departmentName: deparment_data?.departmentName
        ? deparment_data?.departmentName
        : "",
      departmentInitials: deparment_data?.initials
        ? deparment_data?.initials
        : "",
      depoartmentTax: deparment_data?.taxID ? deparment_data?.taxID : "",
      statusButton: deparment_data?.status ? deparment_data?.status : false,
    },
    onSubmit: async (c) => {
      if (departmentId) {
        showAdminLoading();

        const body = {
          departmentId: departmentId,
          departmentName: c.departmentName,
          TaxID: c.depoartmentTax,
          Initials: c.departmentInitials,
          Status: c.statusButton,
        };

        await dispatch(updateDepartment(body));
        hideAdminLoading();
      } else {
        if (fileImage.length !== 0) {
          const body = {
            departmentId: null,
            departmentName: c.departmentName,
            TaxID: c.depoartmentTax,
            Initials: c.departmentInitials,
            Status: 1,
          };
          if (dispatch(AddDepartment(body, fileImage))) {
            history.push("/admin/setting/department");
          }
        }
      }
    },
  });

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="Department" />

      <form onSubmit={formik.handleSubmit} id="emp-form">
        <div className={classes.warpSubHeader}>
          <AdminTitle2 subTitle="Department Informations" />
          {departmentId ? (
            <Switch
              value={formik.values.statusButton}
              checked={formik.values.statusButton}
              onChange={(event) => {
                if (event.target.checked) {
                  formik.setFieldValue("statusButton", true);
                }
                if (!event.target.checked) {
                  formik.setFieldValue("statusButton", false);
                }
              }}
            />
          ) : null}
          <div className={classes.wrapContoller}>
            <Button
              variant="contained"
              size="medium"
              color="primary"
              type="submit"
              onClick={() => {}}
              className={classes.buttonDialogSave}
            >
              Save
            </Button>
          </div>
        </div>

        <div className={classes.wrapContent}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>ชื่อหน่วยงาน</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="departmentName"
                  value={formik.values.departmentName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("departmentName", formik)}
                  helperText={getErrorMessage("departmentName", formik)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>อักษรย่อหน่วยงาน</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="departmentInitials"
                  value={formik.values.departmentInitials}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("departmentInitials", formik)}
                  helperText={getErrorMessage("departmentInitials", formik)}
                />
              </div>
            </Grid>

            <Box width="100%" />
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>หมายเลขประจำตัวผู้เสียภาษี</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="depoartmentTax"
                  value={formik.values.depoartmentTax}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("depoartmentTax", formik)}
                  helperText={getErrorMessage("depoartmentTax", formik)}
                />
              </div>
            </Grid>

            <>
              <Box width="100%" />
              <Grid item xs={12} md={4}>
                <div className={classes.wrapField}>
                  <input
                    accept="image/*"
                    className={classes.input}
                    style={{ display: "none" }}
                    id="raised-button-file"
                    multiple
                    type="file"
                    onChange={async (e) => {
                      if (e.target.value != "") {
                        if (
                          departmentId === "" ||
                          departmentId === "undefined" ||
                          departmentId === undefined
                        ) {
                          setFileImage(e.target.files[0]);
                        } else {
                          try {
                            const response =
                              await FileService.uploadFileImageDepartment({
                                file: e.target.files[0],
                                Status: true,
                                departmentId: departmentId,
                              });

                            if (response.status) {
                              getDetail_Data();
                              const MySwal = withReactContent(Swal);

                              MySwal.fire({
                                icon: "success",
                                didOpen: () => {
                                  MySwal.clickConfirm();
                                },
                              }).then(() => {
                                return MySwal.fire(
                                  "สำเร็จ !",
                                  "แก้ไขรูปภาพหน่วยงานสำเร็จ !",
                                  "success"
                                );
                              });
                            } else {
                              const MySwal = withReactContent(Swal);

                              MySwal.fire({
                                icon: "error",
                                didOpen: () => {
                                  MySwal.clickConfirm();
                                },
                              }).then(() => {
                                return MySwal.fire(
                                  "ผิดพลาด !",
                                  "แก้ไขรูปภาพไม่สำเร็จ โปรตรวจสอบ !",
                                  "error"
                                );
                              });
                            }
                          } catch (error) {
                            console.log("Upload error", error);
                          }
                        }
                      }
                    }}
                  />
                  <label htmlFor="raised-button-file">
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                    >
                      เลือกรูปภาพหน่วยงาน
                    </Button>
                  </label>
                </div>
              </Grid>
            </>

            <Box width="100%" />
            {departmentId && deparment_data?.path !== null ? (
              <Grid item xs={12} md={4}>
                <div className={classes.wrapField}>
                  <InputLabel>โลโก้หน่วยงาน</InputLabel>
                  <Box
                    component="img"
                    sx={{
                      height: 233,
                      width: 350,
                      maxHeight: { xs: 233, md: 167 },
                      maxWidth: { xs: 350, md: 250 },
                      marginTop: 5,
                      borderRadius: 5,
                    }}
                    src={img + deparment_data?.path}
                  />
                </div>
              </Grid>
            ) : null}
            {fileImage.length !== 0 ? (
              <Grid item xs={12} md={4}>
                <div className={classes.wrapField}>
                  <InputLabel>โลโก้หน่วยงาน</InputLabel>
                  <Box
                    component="img"
                    sx={{
                      height: 233,
                      width: 350,
                      maxHeight: { xs: 233, md: 167 },
                      maxWidth: { xs: 350, md: 250 },
                      marginTop: 5,
                      borderRadius: 5,
                    }}
                    src={URL.createObjectURL(fileImage)}
                  />
                </div>
              </Grid>
            ) : null}
          </Grid>
        </div>
      </form>
    </Paper>
  );
}

export default DepartmentDetailPage;
